import script from "./QuestionRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionRadio.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionRadio.vue?vue&type=style&index=0&id=9cddf33a&lang=scss"

const __exports__ = script;

export default __exports__